import { render } from '@tempots/dom'
import { App } from './app'

const app = document.getElementById('app')

if (!app) {
  throw new Error('App element not found')
}

render(App(), app)
